import { render, staticRenderFns } from "./SimpleAgreement.vue?vue&type=template&id=ccaa5ed2&scoped=true"
import script from "./SimpleAgreement.vue?vue&type=script&lang=js"
export * from "./SimpleAgreement.vue?vue&type=script&lang=js"
import style0 from "./SimpleAgreement.vue?vue&type=style&index=0&id=ccaa5ed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccaa5ed2",
  null
  
)

export default component.exports